/** Emblème Generex : l'icône de l'application iPad, aux coins arrondis comme sur l'écran d'accueil. */
export function GenerexMark({ size = 28 }: { size?: number }) {
  return (
    <img
      src="/generex-icon.png"
      width={size}
      height={size}
      alt="Generex"
      draggable={false}
      className="shrink-0 rounded-[22.5%]"
    />
  );
}

/** Titre « GENEREX Web », dans la police de l'interface, en gras. */
export function GenerexWordmark() {
  return (
    <span className="flex items-baseline gap-1.5 text-[14px] font-bold">
      <span className="tracking-[0.06em] text-ink">GENEREX</span>
      <span className="text-ink-muted">Web</span>
    </span>
  );
}
